module.exports = __webpack_public_path__ + "img/zh_cn.0ce57770.png";